import { ScaleStyle, ValuesConfig } from "../types"

// Fills array with the same value for all indexes
export const ScaleValuesStatic = (n: number, v: number) => Array.from(new Array(n)).map(() => v)

// Linear scaling is reverse order
//
// 10 teams: 1st=10, 2nd=9, 3rd=8, ...
export const ScaleValuesLinear = (n: number, offset: number) =>
	Array.from(new Array(n - offset)).map((_, i) => n + offset - i)

// Exponential scaling is using linear values to scale exponentially
//
// 10 teams: 1st=pow(base, power*10), 2nd=pow(base, power*9), 3rd=pow(base, power*8), ...
//
// To see potential values, run this script in node or your browser:
// Note: The last 3 values are: teams, base, power
//
// ((t,b,p) => Array.from(new Array(t)).map((_, i) => Math.pow(b, p*(t-i))))(10, 1.2, 1)
export const ScaleValuesExponential = (n: number, offset: number, base: number, power: number) =>
	ScaleValuesLinear(n, offset).map((x) => Math.pow(base, power * x))

// Fibonacci scaling is using Fibonacci sequence in reverse order
//
// First 12 Fibonacci numbers: 0, 1, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89
// 6 teams:
// - take first 6 values: 0, 1, 1, 2, 3, 5
// - reverse values: 1st=5, 2nd=3, 3rd=2, 4th=1, 5th=1, 6th=0
//
// To see potential values, run this script in node or your browser:
//
// ((t,v=[1,0],n=2)=>{while (n++<t) v.unshift(v[0]+v[1]); return v})(10)
export const ScaleValuesFibonacci = (n: number, offset: number) => {
	const values = [1, 0]
	let size = 2

	while (size++ < n + offset) {
		values.unshift(values[0] + values[1])
	}

	return values.slice(0, n - offset)
}

export const ValuesConfigToScaleValues = (config: ValuesConfig) => (n: number, offset: number) => {
	let values: number[] = []

	switch (config.scaleStyle) {
		case ScaleStyle.Linear:
			values = ScaleValuesLinear(n, offset)
			break
		case ScaleStyle.Exponential:
			values = ScaleValuesExponential(n, offset, config.exponent.base, config.exponent.power)
			break
		case ScaleStyle.Fibonacci:
			values = ScaleValuesFibonacci(n, offset)
			break
		case ScaleStyle.Easing:
			values = ScaleValuesLinear(n, offset)
			if (config.easing.reverse) {
				values.reverse()
			}
			values = values.map((x) => config.easing.fn((x - 1) / (n - 1)))
			break
	}

	return values.map((x) => x * config.scaleFactor)
}
